import {
    GETWALLETOWNERIDNAMELISTAPI_SUCCESS,
	GETWALLETOWNERIDNAMELISTAPI_FAILED,
	RESET_GETWALLETOWNERIDNAMELISTAPI,
	LOADING_GETWALLETOWNERIDNAMELISTAPI,
	NETWORK_ERROR_GETWALLETOWNERIDNAMELISTAPI
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETWALLETOWNERIDNAMELISTAPI:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETWALLETOWNERIDNAMELISTAPI_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETWALLETOWNERIDNAMELISTAPI_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETWALLETOWNERIDNAMELISTAPI:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETWALLETOWNERIDNAMELISTAPI:
            return (state = initialState);
        default:
            return state;
    }
};
